import { render, staticRenderFns } from "./CredentialEdit.vue?vue&type=template&id=55c2bcd8&scoped=true&"
import script from "./CredentialEdit.vue?vue&type=script&lang=ts&"
export * from "./CredentialEdit.vue?vue&type=script&lang=ts&"
import style0 from "./CredentialEdit.vue?vue&type=style&index=0&id=55c2bcd8&prod&lang=scss&scoped=true&"
import style1 from "./CredentialEdit.vue?vue&type=style&index=1&id=55c2bcd8&prod&module=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "55c2bcd8",
  null
  
)

export default component.exports